import TextFieldInput from '../Text';

import './index.scss';

export default function TelegramUsername(props) {
    props.field.options = props.field.options || {};
    props.field.options.regexp = '^[A-Za-z0-9_]*$';

    return <TextFieldInput
        {...props}
        prefix="@"
    />
}
